import { createRoot } from 'react-dom/client';
import { AppProvider } from '@/app/providers/AppProvider';
import '@/app/styles/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(<AppProvider />);
